module.exports = __webpack_public_path__ + "img/gift_250.12c59b63.webp";